export default __webpack_public_path__ + "static/media/motorcycleDealer.4e987122.png";